module.exports = __webpack_public_path__ + "img/store_title01.fc6f210e.png";